<template>
	<div class="contentPage">
		<main-table-all-back
				v-if="driversLimit"
				textCreate="Add driver"
				flag="drivers"
				page-title="Drivers"
				:headers="headers"
				:settings="getSettings"
				:filtersList="driversFilters"
				:list="driversList"
				:defaultOrder="driversOrder"
				:defaultSort="driversSort"

				:totals="driversTotals"
				:total-pages="driversTotal"
				:limit-pages="driversLimit"
				:pages="[ 15, 50, 100, 200, 500, 'All' ]"
				:uniqId="uniqId"
				@updateSettings="onSettingsOpen"
				@updateEvent="onEvent"
				@updateClickButton="onClickButton"
				@updateList="onList"
				@updateEdit="onEdit"
				@updateRefreshFilters="onUpdateFilters(defaultFilter)"
				@updateExport="onExport"
				isExport
				is-create
				:permissionsCreate="permissionsCreate()"
				is-settings

				:externalRefreshKey="externalRefreshKey"
				:externalResetKey="externalResetKey"
				:externalResetMode="externalResetMode"
		></main-table-all-back>
		<table-settings
				v-if="isTableSettingsDrawer"
				@updateSettingsSave="onSettingsSave('drivers')"
				@updateSettingsCancel="onSettingsCancel"
				@updateSettingsClose="onSettingsClose"
				@updateSettingsAll="onSettingsAll"
				:settings="getSettings"
		></table-settings>
		<remove-block
				v-if="isRemove"
				@updateRemoveItem="onRemoveItem"
				@updateRemoveClose="onRemoveClose"
		></remove-block>
		<drivers-form
				v-if="isDriversForm"
				:permissions="permissions"
				:driverId="driverId"
				@updateClose="onCloseDialog"
		></drivers-form>
		<preview-document v-if="previewLink"></preview-document>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// components
import DriversForm from "@/components/Maintenance/Drivers/DriversForm/DriversForm";
// shared
import PreviewDocument from "@/shared/PreviewDocument/PreviewDocument";
import MainTableAllBack from "@/shared/MainTableAllBack/MainTableAllBack";
// mixins
import settingsMixins from "@/mixins/settingsMixins";
import removeMixins from "@/mixins/removeMixins";
// constants
import { PERMISSIONS } from "@/constants/constants";
import { getPermissionsMod } from "@/helper/getPermissionsMod";
import getUniqId from "@/helper/getUniqId";

export default {
	name: "Drivers",
	mixins: [ settingsMixins, removeMixins ],
	components: { PreviewDocument, MainTableAllBack, DriversForm },
	computed: mapGetters([
		"driversList",
		"driversFilters",
		"driversTotals",
		"permissions",
		"driversOrder",
		"driversLimit",
		"driversSort",
		"driversTotal",
		"previewLink",
		'permissionsDefault',
	]),
	data: () => ({
		isDriversForm: false,
		defaultFilter: null,
		activeTableFilters: null,
		driverId: null,

		externalRefreshKey: null, // Обновление списка с фильтрами
		externalResetKey: null, // Сброс фильтров
		externalResetMode: 'default', // Тип сброса фильтров ('default' сброс до дефолтніх фильтров) | ('empty' спрос всех фильтров)

	}),
	methods: {
		...mapActions([ 'getDrivers', 'getDriversFilters', 'actionPreloader', 'onExportLink', 'onDriversRemoveItem' ]),
		permissionsCreate() {
			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.MAINTENANCE, PERMISSIONS.DRIVERS, PERMISSIONS.CREATE ];
			return !getPermissionsMod({ list, path });
		},
		onCloseDialog(isRefresh) {
			this.isDriversForm = false;
			if (isRefresh) {
				// this.onUpdateFilters(this.defaultFilter);
				this.externalRefresh();
			}
		},
		async onRemoveItem() {
			const { status } = await this.onDriversRemoveItem(this.removeId);
			if (status) this.isRemove = false;
			// await this.onUpdateFilters(this.defaultFilter);
			this.externalRefresh();
		},
		async onEvent(flag) {
			if (flag === 'create') {
				this.isDriversForm = true;
				this.driverId = null;
			}
		},
		async onUpdateFilters(filters, isWithoutFilters) {
			await this.getDrivers(filters);
			if (!isWithoutFilters) await this.getDriversFilters(filters);
		},
		async onList(values) {
			const { value, flag } = values;
			// сохраняем выбранные фильтры отдельно
			this.activeTableFilters = value;

			switch (flag) {
				case "sorting":
					await this.getDrivers(value);
					break;
				case "page":
					await this.onUpdateFilters(value, true);
					break;
				default:
					await this.onUpdateFilters(value);
			}
		},
		async onExport(values) {
			await this.onExportLink({ values, requestKey: 'drivers' });
		},
		async onClickButton({ key, item }) {
			if (key === 'edit') {
				if (this.permissions[PERMISSIONS.EDIT] || this.permissions[PERMISSIONS.VIEW]) {
					this.driverId = item.id;
					this.isDriversForm = true;
				}
			}

			if (key === "delete") {
				if (this.permissions[PERMISSIONS.DELETE]) {
					this.getRemoveItem(item.id);
				}
			}
		},
		onEdit({ line }) {
			if (this.permissions[PERMISSIONS.EDIT]) {
				this.driverId = line.id;
				this.isDriversForm = true;
				
			}
		},
		externalRefresh() {
			// обновить таблицу, сохранив текущие фильтры
			this.externalRefreshKey = getUniqId();
		},
		externalReset(mode) {
			// 'default' | 'empty' (default до дефолтних | empty усі фільтра)
			this.externalResetMode = mode;
			this.externalResetKey = getUniqId();
		},

	},
	async mounted() {
		await this.onUpdateFilters();
	}
};
</script>
